// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VZEg","colBig":"styles_colBig__1bqq1","colSmall":"styles_colSmall__qUiNp","shopifyNameWrapper":"styles_shopifyNameWrapper__hvBPV"};